import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import Quote from '../../../components/Quote';
import props from '../../../lib/contentLayoutProps/the-kingston-difference/layoutProps';

import eliza from './eliza@large.jpg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="head-principal-welcome">
    <h1>總校長歡迎辭</h1>
    <div className={styles.wrapper}>
      <div className={styles.text}>
        <Quote styles={{ marginTop: '16px' }}>
          <p>
            本人謹代表京斯敦幼兒園／京斯敦幼稚園／京斯敦國際學校，誠邀您瀏覽本校網址，認識本校的獨特及重要之處。希望各位喜歡瀏覽本校網站，並可於將來親身到本校參觀。
          </p>
        </Quote>
        <p>
          京斯敦分為學前遊戲班、幼兒園、幼稚園及小學部，由來自多元文化背景的高學歷教師帶領，共同實踐本校雙語小班教學的理念。學生從京斯敦畢業後，可以選擇升讀本校直屬中學ICHK，繼續接受小型學校的教學模式。
        </p>
        <p>
          自一九九四年起，京斯敦已致力培養學生學習二十一世紀下最重要的兩種語言：英語及中文(普通話)。二十多年來，京斯敦成功向學生提供一個具挑戰性和啟發性的環境，培養他們均衡發展，並使他們能以個人獨特的方式去成長為一個活躍主動和負責任的世界公民。
        </p>
        <p>
          京斯敦是香港首間獲授權推行國際文憑小學課程的學校，對此，我們感到非常驕傲。國際文憑小學課程為學生提供一個獨特的學習框架。在國際文憑組織的彈性體制下，京斯敦能夠保持雙語教學的方向，同時確保英語、數學、社會科學、科學、美術及體育科的教學素質，並為學生提供卓越的中文學習環境。
        </p>
        <p>
          京斯敦大家庭的成員參觀學校時，每每都會讚嘆學生們流暢轉換中文及英語的能力，這亦是我們引以為傲之處。一般學校只視語言為科目，而京斯敦對於學生能將中英兩種語言融入生活尤其感到自豪。
        </p>
        <p>
          國際文憑教育重視多元教育經驗、觀點及終身學習，而京斯敦的老師來自世界各地，而且教學經驗豐富。通過教師的自身經驗及學校的致力培訓，我們深入理解國際文憑課程的框架，進而發展出一套成熟、創新、成功及以學生為本的教育課程，並藉此吸引不同教育學者加入京斯敦。
        </p>
        <p>希望您能於不久的將來到訪本校。請參加我們定期舉辦的學校參觀團，認識我們傑出的師生，感受舒適的校內環境！</p>
      </div>
      <div className={styles.image}>
        <img src={eliza} alt="Eliza Wong, Head Principal" />
        <div className={styles.caption}>
          總校長<br />黃庭芳
        </div>
      </div>
    </div>
  </ContentLayout>
);
